// extracted by mini-css-extract-plugin
export default {"wrapper":"zbqCER9ZFUxTCKW0zvVD","link":"dbSqfopXaK3R5Q4kcCH4"};